import "../css/Pasos.css";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Banner from "../components/Header";
import LottieAnim from "../components/LottieAnim";
import { SOLICITUD_ESTADOS } from "../config/solicitud";
import { buildWhatsAppUrl, WHATSAPP_MESSAGES } from "../config/whatsapp";
import { useContactSettings } from "../components/ContactSettingsProvider";

const normalizeName = (value) => {
  const trimmed = String(value || "").trim();
  return trimmed ? trimmed.toUpperCase() : "TU SOLICITUD";
};

function SolicitudExitosa() {
  const { whatsappPhone } = useContactSettings();
  const navigate = useNavigate();
  const location = useLocation();
  const { nombre, estado } = location.state || {};
  const displayName = normalizeName(nombre);
  const isPreaprobada = estado === SOLICITUD_ESTADOS.PREAPROBADA;
  const isRechazada = estado === SOLICITUD_ESTADOS.RECHAZADA;
  const title = isPreaprobada
    ? "¡Tu solicitud fue preaprobada!"
    : isRechazada
    ? "Tu solicitud fue rechazada"
    : "Tu solicitud quedó pendiente";
  const message = isPreaprobada
    ? `Muchas gracias ${displayName}. Guardamos tu solicitud. Continuá el proceso por WhatsApp.`
    : isRechazada
    ? `Muchas gracias ${displayName}. Guardamos tu solicitud, pero no podemos continuar con la aprobación.`
    : `Muchas gracias ${displayName}. Guardamos tu solicitud y quedó pendiente de revisión.`;

  const handleNuevaSolicitud = () => {
    navigate("/");
  };

  return (
    <div>
      <div className="banner__container">
        <Banner />
      </div>
      <div className="verification__container">
        <div className="verification__container__panel">
          <div className="verification__container__panel_left">
            <div className="verification__container__image_img-container">
              <LottieAnim width={600} height={600} />
            </div>
          </div>
          <div className="verification__container__panel_right">
            <h2 className="success-title">{title}</h2>
            <p className="success-message">{message}</p>
            <div className="verification__actions">
              <div className="spacer__cuil">
                {isPreaprobada ? (
                  <a
                    href={buildWhatsAppUrl(WHATSAPP_MESSAGES.PREAPROBADA, whatsappPhone)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="verification__btn"
                  >
                    Continuar por WhatsApp
                  </a>
                ) : (
                  <button className="verification__btn" onClick={handleNuevaSolicitud}>
                    Finalizar
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SolicitudExitosa;
